module.exports = __webpack_public_path__ + "img/1.08507f9b.jpg";